import { FC } from "react";
import { Flex, Box, SimpleGrid, AspectRatio } from "@chakra-ui/react";
import SkeletonBox from "../SkeletonBox";
import SkeletonPageFrame from "./SkeleteonPageFrame";
import SkeletonPageTitle from "../SkeletonPageTitle";

const SkeletonDashboardPage: FC = () => (
  <SkeletonPageFrame>
    <SkeletonPageTitle />

    <Flex
      gap={[12, null, 16]}
      flexDirection={["column", null, "row"]}
      justifyContent="space-between"
    >
      <Box flex="1 0 auto">
        <SimpleGrid
          flexGrow={1}
          columns={[2, null, 3]}
          gap={6}
          w="100%"
          maxWidth={720}
          fontWeight="bold"
        >
          {Array.from({ length: 6 }).map((_, index) => (
            <AspectRatio key={index} ratio={1}>
              <SkeletonBox borderRadius={10} />
            </AspectRatio>
          ))}
        </SimpleGrid>
      </Box>

      <Flex flexDirection="column" gap={3} w="100%" maxWidth={400}>
        <SkeletonBox h={150} w="100%" borderRadius={10} />
        <SkeletonBox h={200} w="100%" borderRadius={10} />
      </Flex>
    </Flex>
  </SkeletonPageFrame>
);

export default SkeletonDashboardPage;
